// A collapsible paragraph of help, beside the thing it explains.
//
// Closed by default, on purpose. The screens that carry one are screens an
// author uses every day — the values of a section, the types behind them —
// and a paragraph that is always open is read once and scrolled past forever
// after. So it is a single line with an info icon, and the explanation opens
// under it when it is wanted.
//
// It is one `button` rather than a `content-collapse`: that component is a
// section heading with a chevron and a full-height scroll pane, for content
// that is the screen. This is a footnote.
//
// The toggle is a real button with `aria-expanded`, so a screen reader announces
// it as one, and it is NOT a link: `.nav-tabs` locators in the e2e suites
// address tabs by `link` role, and a link-shaped toggle sitting in a tab body
// would be one more candidate for them to match.
import React, { useState } from "react";

export default ({ label = "What is this?", children, initial = false }) => {
  const [open, setOpen] = useState(initial);

  return (
    <div className="mb-3 help">
      <button
        type="button"
        className="btn btn-link btn-sm p-0"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <i className="fa fa-info-circle" aria-hidden="true"></i> {label}
      </button>
      {open ? (
        <div className="alert alert-info small mt-2 mb-0" role="note">
          {children}
        </div>
      ) : null}
    </div>
  );
};
